import { LessonActivity, LessonActivityModel } from "../../../modules/lesson/activity/activity.types"
import React, { useEffect, useState } from "react"
import { ActivityGame, GameMetatdata } from "../../../modules/games/game"
import { gamesLookupService } from "../../../modules/games/games-lookup"
import { Button } from "reactstrap"
import { useNavigate } from "react-router-dom"
import gameIcon from "assets/assets/images/services-icon/game.svg"
import { buildRelativeUrl } from "../../../common/utils/web-utils"
import awicon from "../../../assets/images/services-icon/coin.png"
import { SessionLessonData } from "../../../modules/lesson/activity/session"
import { onFlexi, sessionIsCompleted } from "../../../modules/lesson/activity/session-util"


type GameActivityCardProps = {
  activity: LessonActivity,
  sessionLessonData?: SessionLessonData,
}


export const GameActivityCard = ({ activity, sessionLessonData }: GameActivityCardProps) => {

  const navigate = useNavigate()
  const [game, setGame] = useState<ActivityGame>()

  const subject = activity.fk_sub_id
  const sessionKey = activity.fk_sest_key
  const activityModel = new LessonActivityModel(activity)

  function navigateToGame() {
    const params = {
      session_key: sessionKey,
      subject: subject,
      homework: activity.marked_for_homework,
      mode: 'activity',
      activityKey: activity.pk_lesson_activity_key
    }
    const url = buildRelativeUrl(`/game`, params);
    navigate(url);
  }

  function navigateToGameSummary() {
    navigate(`/game-summary/${activity.pk_lesson_activity_key}`)
  }

  function GameHomeworkActivityAccess() {

    if(!activity.marked_for_homework) return null;

    if(activityModel.isCompleted()) {
      return (
        <>
          <div className="d-flex align-items-center text-success fw-bold text-uppercase">
            <span className="mcr-success"></span>
            <span onClick={navigateToGameSummary}>Completed</span>
          </div>
        </>
      )
    }
    if(!activityModel.isCompleted()){
      return (
        <>
          <Button className="btn btn-danger cs-btn-danger text-uppercase"
                  onClick={navigateToGame}>
            Start
          </Button>
        </>)
    }
  }

  function GameLessonActivityAccess() {

    const sessionLesson = sessionLessonData?.session

    if(activity.marked_for_homework || !sessionLesson) {
      return null;
    }

    if (parseInt(String(sessionLesson.ses_status)) !== 1){
      return(
        <>
          <div className="d-flex align-items-center text-dark fw-bold text-uppercase">
            <span>SESSION HAS NOT BEEN STARTED</span>
          </div>
        </>
      )}

    if(parseInt(String(sessionLesson.ses_status)) === 1){
      if ( (!sessionIsCompleted(sessionLessonData) || onFlexi(sessionLessonData)) && !activityModel.isCompleted()) {
        return (
          <>
            <Button className="btn btn-danger cs-btn-danger text-uppercase"
                    onClick={navigateToGame}>
              Start
            </Button>
          </>)
      }

      if ( sessionIsCompleted(sessionLessonData) && !onFlexi(sessionLessonData)
        && !activityModel.isCompleted()){
        return (<>
          <div className="d-flex align-items-center text-danger fw-bold text-uppercase">
            <span>Missed</span>
          </div>
        </>)
      }

      if(activityModel.isCompleted()) {
        return (
          <>
            <div className="d-flex align-items-center text-success fw-bold text-uppercase">
              <span className="mcr-success"></span>
              <span onClick={navigateToGameSummary}>Completed</span>
            </div>
          </>
        )
      }
    }

    return null;
  }

  function GameActivityAccess() {
    if(activity.marked_for_homework)
      return <GameHomeworkActivityAccess />

    return <GameLessonActivityAccess />

  }

  useEffect(() => {
    gamesLookupService.getGames().then(games => {
      const _game = games.find(game => game.id === activity.fk_activity_node_id)
      setGame(_game)
    })
  }, [])

  if (!game) {
    return <div></div>
  }

  return (
    <>
      <div className="d-flex align-items-start">
        <div className="hw-icon me-3">
          <img width={36} className="" src={gameIcon} alt="" />
        </div>
        <div>
          <p className="text-warning mb-2 fw-bold font-size-12 text-uppercase">
            Game
          </p>

          <h4 className="fw-bold font-size-24">
            {game?.name}
          </h4>

          <div className="d-flex align-items-center font-size-18 fw-medium me-3">
            <img width={24} className="me-2" src={awicon} alt="" />
            {activityModel.getCoinsEarned()??0}/{GameMetatdata.coinsPerGame} Coins
          </div>
        </div>
      </div>

      <div className="direct_link">
        <div className="hw-status text-end">
          <GameActivityAccess />
        </div>
      </div>

    </>
  )

}